import { createContext, useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import useToggleOpen from '@app/hooks/useToggleOpen'

const AddNoteModal = createContext()

export const useNotesModal = () => useContext(AddNoteModal)

const AddNoteModalProvider = ({ children }) => {
  const [noteType, setNoteType] = useState(null)
  const [draftNote, setDraftNote] = useState({
    content: '',
    uid: '',
  })
  const [anchorel, handleClick, handleClose] = useToggleOpen(null)
  const open = Boolean(anchorel)

  useEffect(() => {
    anchorel === null &&
      setDraftNote({
        content: '',
        uid: '',
      })
  }, [anchorel])

  const value = { open, noteType, handleClick, handleClose, setNoteType, setDraftNote, draftNote }

  return <AddNoteModal.Provider value={value}>{children}</AddNoteModal.Provider>
}

AddNoteModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AddNoteModalProvider
